import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import { ReactComponent as Info } from "../../assets/icons/information.svg";
import { ReactComponent as Error } from "../../assets/icons/error.svg";
import { ReactComponent as Success } from "../../assets/icons/success.svg";
import { ReactComponent as Warning } from "../../assets/icons/warning.svg";
import styles from "./AlertBox.module.scss";

const AlertBox = ({
  variant = "info",
  title,
  subtitle,
  children,
  className,
  style,
  hideIcon = false,
}) => {
  const variantConfig = {
    success: {
      background: "#2E7D32",
      icon: Success,
    },
    error: {
      background: "#2E7D32",
      icon: Error,
    },
    info: {
      background: "#E5F6FD",
      iconColor: "#0288D1",
      icon: Info,
    },
    warning: {
      background: "#FFF4E5",
      iconColor: "#EF6C00",
      icon: Warning,
    },
  };

  const config = variantConfig[variant] || variantConfig.info;
  const IconComponent = config.icon;

  return (
    <Box
      className={`${styles.alertBox} ${className || ""}`}
      style={{
        backgroundColor: config.background,
        ...style,
      }}
    >
      {!hideIcon && (
        <Box
          className={styles.iconContainer}
          style={{ "--icon-color": config.iconColor, padding: 4 }}
        >
          <IconComponent className={styles.icon} />
        </Box>
      )}
      <Box
        className={styles.content}
        style={hideIcon ? { marginLeft: 0 } : undefined}
      >
        {title && (
          <Typography variant="subtitle1" gutterBottom>
            {title}
          </Typography>
        )}
        {subtitle && (
          <Typography variant="body2" color="textSecondary" gutterBottom>
            {subtitle}
          </Typography>
        )}
        {children}
      </Box>
    </Box>
  );
};

AlertBox.propTypes = {
  variant: PropTypes.oneOf(["info", "warning", "success", "error"]),
  title: PropTypes.string,
  subtitle: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  hideIcon: PropTypes.bool,
};

export default AlertBox;
